export default __webpack_public_path__ + "static/media/feedback-governance.0c1a89f3.png";